import { Button, Checkbox, Modal, Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconExportCookie from '../../../assets/Images/icons/icon-export-cookie';
import CustomizeBannerService from '../../../services/CustomizeBanner.service';

const { Option } = Select;

export default function ModalExport({ detail, open, handelClose }) {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [checkedValues, setCheckedValues] = useState([]);
    const [months, setMonths] = useState([]);
    const [yearForm] = Form.useForm();
    useEffect(() => {
        if (!open) {
            setCheckedValues([]);
        }
    }, [open]);

    useEffect(() => {
        let listMonths = [
            {
                id: 1,
                month: 'Jan',
            },
            {
                id: 2,
                month: 'Feb',
            },
            {
                id: 3,
                month: 'Mar',
            },
            {
                id: 4,
                month: 'Apr',
            },
            {
                id: 5,
                month: 'May',
            },
            {
                id: 6,
                month: 'Jun',
            },
            {
                id: 7,
                month: 'Jul',
            },
            {
                id: 8,
                month: 'Aug',
            },
            {
                id: 9,
                month: 'Sep',
            },
            {
                id: 10,
                month: 'Oct',
            },
            {
                id: 11,
                month: 'Nov',
            },
            {
                id: 12,
                month: 'Dec',
            },
        ];
        setMonths(listMonths);
    }, []);

    const onChange = (e) => {
        // console.log('checked = ', e);
        setCheckedValues(e);
        form.setFieldsValue({ months: e });
    };

    const onFinish = async () => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId: detail?.companyId,
            domainId: detail?.domainId,
            period: detail?.period,
            keyword: detail?.ipAddress,
            action: detail?.actionId,
            cookieCategoryEn: detail?.cookieCategoryId,
            month: checkedValues?.toString(),
        };
        if (detail?.yearList.length > 0 ) {
            ObjectSearch.year = yearForm.getFieldValue('yearly');
            ObjectSearch.period = "Yearly"
        }
        try {
            const res = await CustomizeBannerService.getExport(ObjectSearch);
            const data = res?.data;
            if (data) {
                const blob = new Blob([data]);
                yearForm.resetFields(['yearly']);
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveBlob(
                        blob,
                        'cookie-scanner-report.csv'
                    );
                } else {
                    const a = window.document.createElement('a');
                    const filename =
                        res.headers['content-disposition'].split(
                            'filename='
                        )[1];
                    a.href = window.URL.createObjectURL(blob, {
                        type: 'text/plain',
                    });
                    //   a.download = `Cookie_Report_${time}.csv`;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                setTimeout(async () => {
                    await handelClose();
                    await setCheckedValues([]);
                    await form.resetFields();
                }, 500);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Modal
            className="_modal"
            footer={false}
            open={open}
            closable={false}
            onCancel={() => {
                handelClose();
                setCheckedValues([]);
                form.resetFields();
            }}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <IconExportCookie />
                <div className="text-2xl font-semibold">
                    {t('COOKIE.SelectExport')}
                </div>
                <div>{t('COOKIE.SelectPer3Month')}</div>
            </div>
            <div className="flex justify-between mx-2 my-2">
                <div className="font-semibold">
                    {detail?.yearList.length && detail?.yearList.length > 0 ?
                        <Form form={yearForm} layout="vertical">
                            <div className="col-span-2">
                                <p className="ml-2">{t('COOKIE.MonthData')}</p>
                                <Form.Item name="yearly" className="w-full mb-0 mt-2">
                                    <Select
                                        defaultValue={detail?.yearList[0]?.value}
                                        size="large"
                                        style={{ width: 140 }}
                                    >
                                        {detail?.yearList?.map((e, i) => (
                                            <Option key={i} value={e.value}>
                                                {e.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                        </Form>
                        : t('COOKIE.SelectMonth')
                    }
                </div>
                <div className="self-end">{checkedValues?.length}/3</div>
            </div>
            
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item
                    name="months"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group
                        style={{ width: '100%' }}
                        onChange={onChange}
                    >
                        <div className="grid grid-cols-3">
                            {months.map((e) => (
                                <div
                                    key={e.id}
                                    className="col-span-1 border-solid border-[1px] rounded-md mx-2 my-2 py-2 pl-2"
                                    style={{
                                        borderColor: checkedValues.includes(
                                            e.id
                                        )
                                            ? '#7B67FB'
                                            : '#DBDBDB',
                                    }}
                                >
                                    <Checkbox
                                        value={e.id}
                                        disabled={
                                            checkedValues.length > 2
                                                ? checkedValues.includes(e.id)
                                                    ? false
                                                    : true
                                                : false
                                        }
                                        defaultValue={[]}
                                    >
                                        {e.month}
                                    </Checkbox>
                                </div>
                            ))}
                        </div>
                    </Checkbox.Group>
                </Form.Item>

                <div className="flex justify-center items-center space-x-4 my-6">
                    <>
                        <Button
                            type="primary"
                            onClick={() => {
                                handelClose();
                                setCheckedValues([]);
                                form.resetFields();
                            }}
                            size="large"
                            ghost
                            className="px-10"
                        >
                            {t('common.Cancel')}
                        </Button>

                        <Button
                            // onClick={()=> onFinish()}
                            htmlType="submit"
                            size="large"
                            type="primary"
                            className="px-9"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </>
                </div>
            </Form>
        </Modal>
    );
}
